module.exports = __webpack_public_path__ + "media/camille-track-128.ef02f2f6.mp3";